export const appBridge = window.appBridge || {};

export function showLoading(loadingParams) {
    return appBridge.showLoading && appBridge.showLoading(loadingParams);
};

export function hideLoading() {
    return appBridge.hideLoading && appBridge.hideLoading();
};



// WEBPACK FOOTER //
// ./src/util/bridge.js